export default '/@lang/contact'
